import PropTypes from 'prop-types';

import { FlexColumn } from 'ui-components/components/flex';

import style from './enhanced-return-details-grid-layout.module.less';

export const EnhancedReturnDetailsGridLayout = ({ className, addressColumnContent, costSummaryColumnContent, rmaColumnContent }) => {
  return (
    <div className={className}>
      <FlexColumn className={style['address-column']}>{addressColumnContent}</FlexColumn>
      <FlexColumn className={style['rma-column']}>{rmaColumnContent}</FlexColumn>
      <FlexColumn className={style['cost-summary-column']}>{costSummaryColumnContent}</FlexColumn>
    </div>
  );
};

EnhancedReturnDetailsGridLayout.propTypes = {
  className: PropTypes.string,
  addressColumnContent: PropTypes.node.isRequired,
  rmaColumnContent: PropTypes.node.isRequired,
  costSummaryColumnContent: PropTypes.node.isRequired,
};
